<template>
  
 <div class="container" style="margin-top: 1em;">
    <div class="raw">
    <div class="col-1">
    </div>
    <div class="col-11">
      <v-progress-linear  v-if="store.state.waiting"  color="antiquewhite" indeterminate></v-progress-linear>
        <JsonToExcel v-if="['A'].find(el=>el==store.state.user.groupe)"></JsonToExcel>
        <div v-for="marque in store.state.articles">
          <div v-for="theme in marque">
            <h4 style="color:grey"> {{ theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].marque }} | {{ theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].theme }} </h4> 
            <Theme :theme="theme"></Theme>
            <br>
            <br>
          </div>
        </div>
    </div>
  </div> 
</div> 

</template>
<script setup>
  import Theme from './Theme.vue';
  import axios from 'axios'
  import {onMounted, ref } from 'vue'
  import store from './store'
  import JsonToExcel from './JsonToExcel.vue';

  
// const waiting=ref(false)
const articles =ref(store.state.articles)
const getArticles=()=>{  
  store.commit('updateWaiting')   
    let config = {
    method: 'get',
    url: 'https://vps-7154040e.vps.ovh.net:8080https://my.edisac.com/api/theme'
    };
    return   axios.request(config)
    .then((response) => {
      articles.value =response.data;
      store.commit('addArticles',response.data)  
       console.log(response.data);   
       store.commit('updateWaiting')      
    })
    .catch((error) => {
    console.log(error);
    
    });
}
onMounted(() => {

    // getArticles()
  })


</script>